<template>
	<div
		class="sticky-cart insicht insicht--fade-in"
		@click.prevent="onClick"
	>
		<div
			class="sticky-cart__summary"
			v-if="hasBasket"
		>
			<div
				class="sticky-cart__summary-icon"
			>
				<SVGBag/>
				<span
					class="sticky-cart__summary-icon-count"
					v-if="totalItemsWithoutAdditional"
					v-html="totalItemsWithoutAdditional"
				/>
			</div>

			<div class="sticky-cart__summary-details">
				<span
					class="sticky-cart__summary-total"
					v-html="$options.filters.fwgpricecent(displayTotal, 'short')"
				/>
				<span
					class="sticky-cart__summary-shipping"
					v-if="deliveryPrice"
					v-html="$t('cart.deliveryFeePrice', { price: $options.filters.fwgpricecent(deliveryPrice, 'short') })"
				/>
				<span
					class="sticky-cart__summary-shipping-min"
					v-if="deliveryPrice && minCartFreePrice"
					v-html="$t('cart.freeDeliveryThreshold', { price: $options.filters.fwgpricecent(minCartFreePrice, 'short') })"
				/>
			</div>
		</div>

		<Button
			class="sticky-cart__button"
			type="button"
			level="primary"
			:text="hasBasket ? $t('cart.stickyCartButton') : $t('cart.stickyCartStartOrder')"
		/>
	</div>
</template>

<script>
import Button from '@/components/Button';

import { mapGetters } from "vuex"
import htmlComponent from 'htmlcomponent'

export default {
	components: {
		Button,
	},
	props: {
		showCo2: {
			type: Boolean,
			default() {
				return false
			}
		},
		showTip: {
			type: Boolean,
			default() {
				return false
			}
		},
	},
	data() {
		return {
		};
	},
	computed: {
		...mapGetters("cart", [
			"deliveryPrice",
			"minCartFreePrice",
			"total",
			"totalWithoutTip",
			"totalWithoutSurcharges",
			"totalWithoutCo2",
			"totalItemsWithoutAdditional",
			"hasBasket",
		]),
		displayTotal() {
			if (!this.showCo2 && !this.showTip) {
				return this.totalWithoutSurcharges;
			}
			else if (this.showCo2 && !this.showTip) {
				return this.totalWithoutTip
			}
			else if (!this.showCo2 && this.showTip) {
				return this.totalWithoutCo2
			}
			else {
				return this.total
			}
		},
	},
	methods: {
		onClick() {
			if (this.hasBasket) {
				htmlComponent.send('overlay:open', {type: 'sidebar-cart'});
			}
			else {
				htmlComponent.send('overlay:open', {type: 'overlay-orderbox'});
			}
		},
	}
}
</script>

<style>

</style>
